var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-16"},[_c('v-skeleton-loader',{staticClass:"d-flex justify-end justify-sm-space-between flex-column flex-sm-row w-100",attrs:{"type":"button@2"}}),_c('CollectionListingSectionSkeleton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }